import React, {useState} from "react";
import {Button, Card, CardActionArea, CardContent, Grid} from "@mui/material";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {LockClose, Share} from "~/ui/icons";
import {getAutoVisitShareData, ShareAutoVisit} from "~/apps/packages/auto-visits/utils";
import {Dialog} from "~/components/Dialog";
import {Box} from "@mui/system";
import {useBooleanHistoryState} from "~/apps/core/utils";


export type ShareAutoVisitButtonProps = {
    autoVisit: ShareAutoVisit
}


export const ShareAutoVisitButton = (props: ShareAutoVisitButtonProps) => {
    const {autoVisit} = props;
    const canShare = navigator?.share != null && autoVisit.PIN;
    const [openPreview, setOpenPreview] = useBooleanHistoryState("share-preview");

    const handleOpenPreviewClick = () => {
        setOpenPreview(true);
    }

    const handlePreviewCloseClick = () => {
        setOpenPreview(false);
    }

    const handleShareClick = () => {
        setOpenPreview(false);
        navigator?.share(getAutoVisitShareData(autoVisit, "share"));
    }

    return (
        <>
        <Card>
            <CardActionArea disabled={!canShare} onClick={handleOpenPreviewClick}>
                <CardContent>
                    <Grid container direction="column" alignItems="center">
                        <TypographyWithIcon
                            variant="headerTitle"
                            color="additionalPrimary.main"
                            startIcon={<LockClose/>}
                        >
                            PIN {autoVisit.PIN || "————"}
                        </TypographyWithIcon>
                        {canShare && (
                            <TypographyWithIcon
                                marginTop="8px"
                                variant="screenText"
                                color="additionalSecondary.main"
                                startIcon={<Share/>}
                            >
                                Отправить пин-код
                            </TypographyWithIcon>
                        )}
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
            <Dialog open={openPreview} onClose={handlePreviewCloseClick} title="Текст сообщения" actions={(
                <>
                    <Button size="small" color="additionalSecondary" onClick={handlePreviewCloseClick}>
                        Отменить
                    </Button>
                    <Button size="small" color="additionalPrimary" onClick={handleShareClick}>
                        Отправить
                    </Button>
                </>
            )}>
                <Box whiteSpace="pre-line" bgcolor="#F7F7FA" padding="10px" typography={"screenText"}>
                    {getAutoVisitShareData(autoVisit, "text")}
                </Box>
            </Dialog>
        </>
    )
}
